import React from 'react'
import page from 'hoc/page'
import { DI } from 'modules'
import { Redirect } from 'react-router-dom'

import FormSignIn from 'components/form-sign-in'

function SignIn(props) {
  const { common } = props

  return (
    <section className="content">
      <div className="wrap wrap--high">
        {props.user.isSignedIn && <Redirect to={`/${common.locale}`} />}

        <div
          className="sign-in-container j-sign-in"
          style={{ minHeight: props.height }}
        >
          <div className="sign-in-inner sign-in-inner--300">
            <FormSignIn />
          </div>
        </div>
      </div>
    </section>
  )
}

export default page(DI(['user', 'common'])(SignIn))
